import { useEffect, useState } from "react";

import type { PartnerIntent } from "@/api/generated/models";
import { usePartnerIntent } from "@/hooks/usePartnerIntent";

/** The locally held partner intent: undefined while it's being read, null when there is none. */
export const useLocalPartnerIntent = (): PartnerIntent | null | undefined => {
  const { getLocalPartnerIntent } = usePartnerIntent();
  const [partner, setPartner] = useState<PartnerIntent | null | undefined>();
  useEffect(() => {
    let active = true;
    getLocalPartnerIntent().then((intent) => {
      if (active) {
        setPartner(intent?.partner ?? null);
      }
    });
    return () => {
      active = false;
    };
  }, [getLocalPartnerIntent]);
  return partner;
};
